<template>
    <transition name="fade-in-up">
        <router-view></router-view>
    </transition>
</template>

<script>
    export default {
        name: "Ticket"
    }
</script>

<style scoped>

</style>